import React, { useState, useContext } from 'react';
import { Navbar as Bar, Nav } from 'react-bootstrap';
import { Link as A, navigate } from 'raviger';
import styled from 'styled-components';
import { SearchButton, ProfileIcon } from 'components';
import { device } from 'utils/device';
import { I18nContext } from 'i18n';

const Navbar = () => {
  const { translate } = useContext(I18nContext);
  const [expanded, setExpanded] = useState(false);
  const scholarshipproviders = 'https://www.scholarshipproviders.org/';
  const links = [
    { label: 'about', url: `${scholarshipproviders}page/AboutLandingPage` },
    { label: 'join', url: `${scholarshipproviders}page/memberbenefits20` },
    {
      label: 'conference',
      url:
        'https://web.cvent.com/event/ace6f3b2-9180-4b96-a006-8559c0a5e141/websitePage:001f7636-2a46-4119-9be6-9497d6d09e7e',
    },
    { label: 'members', url: `${scholarshipproviders}page/MemberMap` },
    { label: 'learn', url: `${scholarshipproviders}events/event_list.asp` },
    { label: 'marketplace', url: `${scholarshipproviders}store/default.aspx` },
    {
      label: 'career',
      url: `${scholarshipproviders}networking/opening_search.asp`,
    },
  ];

  const handleClick = () => {
    navigate('/search/advanced/programs');
  };

  const renderLinks = () => (
    <Menu className="mr-auto" onClick={() => setExpanded(!expanded)}>
      <Link href="/" as={A}>
        HOME
      </Link>
      {links.map(({ url, label }, ix) => (
        <Link key={ix} href={url} as={A} target="_blank">
          {translate(`menu_${label}`)}
        </Link>
      ))}
    </Menu>
  );

  return (
    <NavBar
      expand="lg"
      variant="dark"
      onToggle={() => setExpanded(!expanded)}
      expanded={expanded}
    >
      <Bar.Toggle aria-controls="basic-navbar-nav" />
      <Bar.Collapse id="basic-navbar-nav">
        {renderLinks()}
        <SearchContainer>
          <SearchButton onClick={handleClick} />
          <ProfileIcon />
        </SearchContainer>
      </Bar.Collapse>
    </NavBar>
  );
};

const Menu = styled(Nav)`
  margin: 0 auto;
`;

const NavBar = styled(Bar)`
  background-color: ${({ theme }) => theme.palette.primary[0]};
  border-top: 1px solid ${({ theme }) => theme.palette.primary[6]};
  border-bottom: 1px solid ${({ theme }) => theme.palette.primary[6]};
  height: 3.3rem;
  margin: 0 auto;

  .navbar-collapse {
    background-color: ${({ theme }) => theme.palette.primary[0]};
    z-index: 2;
  }
`;

const Link = styled(Nav.Link)`
  color: ${({ theme }) => theme.palette.primary[4]} !important;
  margin: 0 1.4rem;
  white-space: nowrap;

  @media ${device.mobileL} {
    margin: 1rem 2rem;
    &:first-child {
      margin: 1rem 2rem;
    }
  }
`;

const SearchContainer = styled.div`
  position: absolute;
  display: flex;
  right: 1rem;
`;

export default Navbar;
